import { useState, useEffect } from 'react';
import PersonalHeader from '../../PersonalDetails/components/header';
import PersonalDetailsContent from '../../PersonalDetails/components/content';
import FormGroup from '../../FormGroup';
import useFetchData from '../../../hooks/useFetchData';
import { ReactComponent as Editicon } from '../../../assets/images/edit.svg';
import usePostData from '../../../hooks/usePostData';
import fields from '../fields';
import { useParams } from 'react-router-dom';
import translating from '../translate.json';

const NotificationPage = () => {
  const { idd } = useParams();
  const [mode, setMode] = useState('view');
  const { postData, res, payload } = usePostData();
  const [currentNotification, setCurrentNotification] = useState({});

  let { data: notificationData } = useFetchData('notifications', idd);

  useEffect(() => {
    setCurrentNotification(notificationData);
  }, [notificationData]);

  useEffect(() => {
    if (res && res.affected === 1 && payload) {
      setCurrentNotification(payload);
      setMode('view');
    }
  }, [res, payload]);

  const onSubmit = (data) => {
    delete data.id;
    console.log('update notification data  :', data);
    postData(`notifications/${idd}`, data, 'patch');
  };

  const handleClickEdit = () => {
    if (mode === 'edit') setMode('view');
    else setMode('edit');
  };

  const actions = [
    {
      icon: Editicon,
      txt: translating.edit,
      handleClickAction: handleClickEdit
    }
  ];

  return (
    <div className="notification-page">
      {notificationData && (
        <div>
          <div className="personal-details">
            <PersonalHeader
              title={translating.msgTile}
              actions={actions}
            ></PersonalHeader>
            <div className="wrapper-details">
              <div className="customer-details">
                {mode === 'edit' ? (
                  <FormGroup
                    fields={fields}
                    data={currentNotification}
                    onSubmit={onSubmit}
                  ></FormGroup>
                ) : (
                  <PersonalDetailsContent
                    fields={fields}
                    data={currentNotification}
                  ></PersonalDetailsContent>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default NotificationPage;
